export const styles = {
  noPadding: 'lg:max-w-full lg:p-0',
};
